import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Hợp đồng lao động › Phát hành. Mã mẫu, tên người, dữ liệu không dịch.
addMessages('vi', {
  'ci.h1': '1 · Nhân viên',
  'ci.h2': '2 · Mẫu hợp lệ',
  'ci.h3': '3 · Thông tin hợp đồng',
  'ci.h4': '4 · Xem trước',
  'ci.a1': '1. Nhân viên',
  'ci.a2': '2. Mẫu hợp lệ',
  'ci.a3': '3. Thông tin hợp đồng',
  'ci.aPv': 'Xem trước hợp đồng',
  'ci.staff': 'Nhân viên',
  'ci.issueFor': 'Phát hành cho',
  'ci.cantUse': 'Không dùng được: {x}',
  'ci.valid': 'Hợp lệ',
  'ci.hint': ' · gợi ý',
  'ci.fNo': 'Số hợp đồng (tự sinh)',
  'ci.fTimes': 'Ký lần thứ',
  'ci.fSign': 'Ngày ký',
  'ci.fFrom': 'Hiệu lực từ',
  'ci.fTo': 'Đến (theo thời hạn mẫu)',
  'ci.fSalary': 'Lương chính (từ hồ sơ / bảng chuẩn)',
  'ci.needMoney': '•••••• cần quyền lương',
  'ci.missField': 'Thiếu 1 trường · bổ sung ở Hồ sơ nhân sự',
  'ci.fullField': 'Đủ trường ghép',
  'ci.tTrial': 'HỢP ĐỒNG THỬ VIỆC',
  'ci.tTrain': 'HỢP ĐỒNG ĐÀO TẠO NGHỀ',
  'ci.tLabor': 'HỢP ĐỒNG LAO ĐỘNG',
  'ci.rep': '[BOD-DIR] PHILIP — Giám đốc',
  'ci.addrC': '•••• (in mới điền)',
  'ci.permAddr': 'thường trú',
  'ci.missAddr': 'thiếu',
  'ci.nation': 'CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM',
  'ci.motto': 'Độc lập – Tự do – Hạnh phúc',
  'ci.no': 'Số: {n}',
  'ci.partyA': 'Bên A:',
  'ci.partyB': 'Bên B:',
  'ci.repOf': 'đại diện',
  'ci.art1': 'Điều 1.',
  'ci.job': 'Công việc:',
  'cti.dept': 'phòng',
  'ci.level': 'cấp bậc',
  'ci.art2': 'Điều 2.',
  'ci.term': 'Thời hạn:',
  'ci.indef': 'không xác định thời hạn',
  'ci.months': '{n} tháng',
  'ci.from': 'từ',
  'ci.until': 'đến',
  'ci.art3': 'Điều 3.',
  'ci.hours': 'Thời giờ làm việc:',
  'ci.hoursSrc': '(lấy từ lịch làm việc công ty)',
  'ci.art4': 'Điều 4.',
  'ci.salary': 'Lương chính:',
  'ci.payDay': 'trả ngày 05 hằng tháng · phụ cấp theo bảng lương chuẩn',
  'ci.art5': 'Điều 5.',
  'ci.insure': 'BHXH, BHYT, BHTN theo quy định',
  'ci.trialNoIns': ' (thử việc: chưa đóng)',
  'ci.leave': 'phép năm',
  'ci.days': '{n} ngày',
  'ci.art6': 'Điều 6.',
  'ci.end': 'Chấm dứt / gia hạn: báo bằng văn bản ít nhất 15 ngày trước khi hết hạn.',
  'ci.print': 'In 02 bản',
  'ci.printing': 'Đang in 02 bản {no} · PDF vector',
  'cti.save': 'Lưu bản nháp',
  'ci.noWrite': 'Chưa mở ghi ở bản này',
  'ci.blocked': 'Mẫu bị chặn: {x}',
  'ci.missToast': 'Còn trường thiếu · bổ sung ở Hồ sơ nhân sự',
});

addMessages('en', {
  'ci.h1': '1 · Employee',
  'ci.h2': '2 · Eligible templates',
  'ci.h3': '3 · Contract details',
  'ci.h4': '4 · Preview',
  'ci.a1': '1. Employee',
  'ci.a2': '2. Eligible templates',
  'ci.a3': '3. Contract details',
  'ci.aPv': 'Contract preview',
  'ci.staff': 'Employee',
  'ci.issueFor': 'Issue to',
  'ci.cantUse': 'Cannot use: {x}',
  'ci.valid': 'Eligible',
  'ci.hint': ' · suggested',
  'ci.fNo': 'Contract no. (auto)',
  'ci.fTimes': 'Signing no.',
  'ci.fSign': 'Signing date',
  'ci.fFrom': 'Effective from',
  'ci.fTo': 'To (per template term)',
  'ci.fSalary': 'Base salary (from profile / standard scale)',
  'ci.needMoney': '•••••• payroll permission required',
  'ci.missField': '1 field missing · add it in the staff profile',
  'ci.fullField': 'All merge fields filled',
  'ci.tTrial': 'PROBATION CONTRACT',
  'ci.tTrain': 'VOCATIONAL TRAINING CONTRACT',
  'ci.tLabor': 'LABOR CONTRACT',
  'ci.rep': '[BOD-DIR] PHILIP — Director',
  'ci.addrC': '•••• (filled at print)',
  'ci.permAddr': 'permanent address',
  'ci.missAddr': 'missing',
  'ci.nation': 'SOCIALIST REPUBLIC OF VIET NAM',
  'ci.motto': 'Independence – Freedom – Happiness',
  'ci.no': 'No.: {n}',
  'ci.partyA': 'Party A:',
  'ci.partyB': 'Party B:',
  'ci.repOf': 'represented by',
  'ci.art1': 'Article 1.',
  'ci.job': 'Position:',
  'cti.dept': 'department',
  'ci.level': 'grade',
  'ci.art2': 'Article 2.',
  'ci.term': 'Term:',
  'ci.indef': 'indefinite term',
  'ci.months': '{n} months',
  'ci.from': 'from',
  'ci.until': 'to',
  'ci.art3': 'Article 3.',
  'ci.hours': 'Working hours:',
  'ci.hoursSrc': '(from the company work calendar)',
  'ci.art4': 'Article 4.',
  'ci.salary': 'Base salary:',
  'ci.payDay': 'paid on the 5th monthly · allowances per standard pay scale',
  'ci.art5': 'Article 5.',
  'ci.insure': 'Social, health and unemployment insurance as regulated',
  'ci.trialNoIns': ' (probation: not yet contributed)',
  'ci.leave': 'annual leave',
  'ci.days': '{n} days',
  'ci.art6': 'Article 6.',
  'ci.end': 'Termination / renewal: written notice at least 15 days before expiry.',
  'ci.print': 'Print 2 copies',
  'ci.printing': 'Printing 2 copies of {no} · vector PDF',
  'cti.save': 'Save draft',
  'ci.noWrite': 'Writing is not open in this version',
  'ci.blocked': 'Template blocked: {x}',
  'ci.missToast': 'Fields missing · add them in the staff profile',
});
